export const professionList = {
  professionMarketing: 'Coordinateur marketing',
  professionWebDesigner: 'Designer Web',
  professionSales: 'Président des ventes',
  professionCoordinator: 'Coordinateur marketing',
};

export const pageTitle = 'Notre équipe';
